import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-modal',
    templateUrl: './app-modal.component.html',
    styleUrls: ['./app-modal.component.css']
})
export class AppModalComponent implements OnInit, OnDestroy {
    private static openModalCount = 0;
    private static previousBodyOverflow = '';

    @Input() width = 'min(460px, calc(100vw - 24px))';
    @Output() dismissed: EventEmitter<void> = new EventEmitter<void>();

    ngOnInit() {
        if (AppModalComponent.openModalCount === 0) {
            AppModalComponent.previousBodyOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        }
        AppModalComponent.openModalCount += 1;
    }

    ngOnDestroy() {
        AppModalComponent.openModalCount = Math.max(0, AppModalComponent.openModalCount - 1);
        if (AppModalComponent.openModalCount === 0) {
            document.body.style.overflow = AppModalComponent.previousBodyOverflow;
        }
    }

    onBackdropMouseDown(event: MouseEvent) {
        if (event.target === event.currentTarget) {
            this.dismissed.emit();
        }
    }
}
